import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HaHeaderServiceService } from '../../services/HaHeader.service';
import { HaProfileInfo } from '../ha-models/ha-profile-info';
import { Noti } from '../../../SuperAdmin/models/Notification.model';
import { WebUserDetails } from '../../../../shared/models/WebUserDetails';
import { HaHeaderViewServiceService } from '../../services/HaHeaderView.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';

@Component({
  selector: 'app-ha-header',
  templateUrl: './ha-header.component.html',
  styleUrls: ['./ha-header.component.css']
})

export class HaHeaderComponent implements OnInit {
  profileInfo: HaProfileInfo;
  notifications: Noti[];
  elementNav: HTMLElement;
  elementNav1: HTMLElement;
  navCounter: number = 0;
  public ViewId: boolean = false;
  notCount: number;
  showSession: boolean = false;
  allUsers: WebUserDetails[];
  userRoleHaHeader: string = null;
  currentUserHaHeader: WebUserDetails;
  allUsersHaHeader: WebUserDetails[];
  newPwd: string = '';
  rePwd: string = '';
  oldPwd: string = '';
  constructor(private router: Router, private _service: HaHeaderServiceService, private viewService: HaHeaderViewServiceService) {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit() {
    this.allUsersHaHeader = JSON.parse(localStorage.getItem('userDetails'));
    if (this.allUsersHaHeader != undefined && this.allUsersHaHeader != null) {
      this.currentUserHaHeader = this.allUsersHaHeader.filter(i => i.id == JSON.parse(sessionStorage.getItem('Id')))[0];
    }
    if (this.currentUserHaHeader != null && this.currentUserHaHeader != undefined) {
      this.userRoleHaHeader = this.currentUserHaHeader.userRole;
    }
    this.getProfileInfo();
    this.getNotifications();
    if (this._service.subsVarHASidebar == undefined) {
      this._service.subsVarHASidebar = this._service.
      invokeFirstComponentFunctionSidebarHA.subscribe(
      (name: string) => {
        this.openCloseNav();
      },
      (error) => {
        AlertMessages.Show('Failed','Could not set Sidebar', AlertType.Error);
      });
    } else {
      this._service.subsVarHASidebar = this._service.
      invokeFirstComponentFunctionSidebarHA.subscribe((name: string) => {
        this.openCloseNav();
      },
      (error) => {
        AlertMessages.Show('Failed','Could not set Sidebar', AlertType.Error);

      });
    }
  }

  logOut() {
    this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
    this.allUsers.splice(this.allUsers.findIndex(user => user.id == JSON.parse(sessionStorage.getItem('Id'))), 1);
    localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
    this.showSession = false;
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  continueSession() {
    this.showSession = false;
  }

  public HandleUserInactivity() {
    this.showSession = true;
  }

  onSubmit(Form: NgForm) {
    this._service.changePassword(Form.value.oldPwd, Form.value.newPwd, Form.value.rePwd).subscribe(
    (data) => {
      AlertMessages.Show('Alert', data['StatusMessage'], data['Id'] == 1 ? AlertType.Success : AlertType.Error);
      Form.reset();
    },
    (error) => {
      AlertMessages.Show('Failed', 'could not change Password!', AlertType.Error);
    });
  }

  deleteNot() {
    const newNots = this.notifications.filter(noti => noti.isNew == true);

    const delNots = [];
    newNots.forEach((i) => {
      delNots.push(i.id);
    });

    if (delNots.length > 0) {
      this._service.removeHaNotifications(delNots).subscribe(
        (Data) => {
          this.notCount = 0;
        },
        (error) => {
          AlertMessages.Show('Failed','Could not update notifications!', AlertType.Error);
        });
    }
  }

  getNotifications() {
    this._service.getNotifications().subscribe(
    (data: Noti[]) => {
      this.notifications = data;
      this.notCount = this.notifications.filter(noti => noti.isNew == true).length;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load Notifications!', AlertType.Error);
    });
  }

  getProfileInfo() {
    this._service.getProfileData().subscribe(
    (data: HaProfileInfo) => {
      this.profileInfo = data;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load user info', AlertType.Error);
      this.logOut();

    });
  }

  clearData(Form: NgForm) {
    Form.reset();
  }

  openCloseNav() {
    this.elementNav = document.getElementById('nav') as HTMLElement;
    if (this.navCounter == 0) {
      this.elementNav.style.display = 'block';
      this.navCounter = 1;
    } else {
      this.elementNav.style.display = 'none';
      this.navCounter = 0;
    }
  }

}
